import { render, staticRenderFns } from "./airline-view.vue?vue&type=template&id=793bc9fc&scoped=true"
import script from "./airline-view.vue?vue&type=script&lang=js"
export * from "./airline-view.vue?vue&type=script&lang=js"
import style0 from "./airline-view.vue?vue&type=style&index=0&id=793bc9fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793bc9fc",
  null
  
)

export default component.exports